var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RatingStars"},_vm._l((_vm.stars),function(star){return _c('span',{key:star,staticClass:"star fa",class:[_vm.starClass(star), _vm.disabled ? 'disabled' : ''],on:{"click":function($event){return _vm.select(star)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }